import { JobRoleApiModel } from '../../../api/journodex/model/job-role-api.model';
import { JobRoleTypeEnum } from '../../../api/journodex/enum/job-role-type.enum';

export class JobRoleModel {
    id: number;
    displayString?: string;
    family?: JobRoleTypeEnum;
    tooltip?: string;

    constructor(apiModel?: JobRoleApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.displayString = apiModel.displayString;
            this.family = apiModel.jobRoleFamily;
        }
    }

    clone(): JobRoleModel {
        return new JobRoleModel(<JobRoleApiModel>{
            id: this.id,
            displayString: this.displayString,
            jobRoleFamily: this.family
        });
    }
}
